export default __webpack_public_path__ + "static/media/13.b2f6456c.jpg";